var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTouchIcon = function SvgTouchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4D5B5A",
    clipPath: "url(#touch-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96 3.21a3.754 3.754 0 0 0-1.373 5.122l1.083-.625A2.5 2.5 0 1 1 8 5.207l1.083-.625A3.754 3.754 0 0 0 3.96 3.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.04 15.865-2.404 1.388a2.5 2.5 0 0 1-1.796.274L5.215 15.82a1.25 1.25 0 0 1-.89-1.69 1.296 1.296 0 0 1 1.492-.738l2.953.65-4.018-6.96a1.25 1.25 0 1 1 2.165-1.25l2.188 3.79a1.25 1.25 0 0 1 2.165-1.25l.312.54a1.25 1.25 0 1 1 2.165-1.25l.313.542a1.25 1.25 0 1 1 2.165-1.25l2.187 3.789a3.75 3.75 0 0 1-1.372 5.122"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "touch-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export { SvgTouchIcon as ReactComponent };